module.exports = __webpack_public_path__ + "img/networkCbtBlack.8dc8f98d.png";